enum ProductCardTakeBackReturnInformationModalEnum {
	takeBackReturnQrCard = 'takeBackReturnQrCard'
}

export default ProductCardTakeBackReturnInformationModalEnum;
